












    import Component from 'vue-class-component'
    import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'

    @Component({
        components: {}
    })

    class TableScrollable extends Vue {
        get Style(){
            return {height:'10px',width:this.width+'px'};
        }
        get WrapperStyle(){
            return {overflow:'auto',width:this.outerWidth+'px'};
        }

        /*
            width of content synchronized with width of inner content of scrollable component
         */
        @Prop()
        width: number;

        /*
            width of container should be equal  size of  container of scrollable element
         */
        @Prop()
        outerWidth: number;

        @Prop()
        value: number;

        @Prop()
        id:string;


        @Watch('value')
        move(newv:number){
            this.$el.scrollLeft = newv;
        }

        @Emit('input')
        update(v:number){

        }

        scroll(e:any){
           this.update(e.srcElement.scrollLeft);
        }

        listenScroll(){
          //  (this.$refs.scroller as any).style!.width = this.width + 'px';
          //  this.$el.scrollLeft = this.value;
//            $(this.$el).scroll(()=>
//                this.update($(this.id +" .table-responsive").scrollLeft())
//            );
        }
//        mounted(){
//            (this.$refs.scroller as any).style!.width = this.width + 'px';
//        }
//        updated(){
//            (this.$refs.scroller as any).style!.width = this.width + 'px';
//        }
//        updated(){
//            Vue.nextTick(()=> {
//
//
//                this.listenScroll();
//            });
//
//        }
//        mounted () {
//            Vue.nextTick(()=>{
//                //const w = ($(this.$el.nextSibling!.children[0])! as any).offsetWidth+'px';
//                //console.log(w);
//
//
//            });
//        }
    }

    export default TableScrollable;
